const o="roq",t="roq-",i="/notification-ws";export{t as COMPONENT_CLASS_PREFIX,i as NOTIFICATION_WS_PATH,o as ROQ_PREFIX};